var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"small-margin-right",on:{"click":function($event){return _vm.block_product()}}},[_vm._v("Block all variants")]),_c('button',{on:{"click":function($event){return _vm.unblock_product()}}},[_vm._v("Unblock all variants")]),_c('Table',{attrs:{"columns":_vm.block_tab_columns,"rows":_vm.block_tab_rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }